if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {

	/*
		HOME ARROW
		$('.arrow-home').click(function(event) {
			$('body, html').animate({
				scrollTop: $(window).height()-$('header').outerHeight()*2},
				800, 'easeOutExpo');
		});
	*/

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))

	var slideCount = jQuery('.slide').length
	if (slideCount <= 2 && slideCount > 1) {
		jQuery('.highlights__slider').children().clone(true, true).appendTo('.highlights__slider')

		//ADA PURPOSES
		jQuery('.highlights__slider')
			.children()
			.each(function (index) {
				let contentBox = $(this).find('.content-lightbox > .fancy-higlights')
				let linkBox = $(this).find('.content-lightbox > .learnmore')
				if (contentBox.attr('id') != undefined) {
					contentBox.attr('id', `${contentBox.attr('id')}-${index}`)
					linkBox.attr('href', `${linkBox.attr('href')}-${index}`)
				}
			})
	}

	$('.sym-slides').slick({
		accessibility: true,
	})

	$('.slider-second-slider').slick({
		accessibility: true,
		fade: true,
		arrows: false,
		dots: false,
		asNavFor: '.slider-first-slider',
	})

	//data-slick='{"fade": true,"arrows":false" , "asNavFor":".slider-first-slider"}'

	$('.sub-menu > ul').slick({
		mobileFirst: true,
		accessibility: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '90px',
		infinite: false,
		responsive: [
			{
				breakpoint: 2000,
				settings: 'unslick',
			},
			{
				breakpoint: 1600,
				settings: 'unslick',
			},
			{
				breakpoint: 1024,
				settings: 'unslick',
			},
			{
				breakpoint: 600,
				settings: {},
			},
		],
	})

	//Slick goto
	var dataSlickIdx = $('.sub-menu .slick-slide').find('.active').parent().attr('data-slick-index')
	$('.sub-menu > ul').slick('slickGoTo', parseInt(dataSlickIdx))

	$('.sym-slides-rooms').slick({
		accessibility: true,
		centerMode: false,
		infinite: false,
		arrows: true,
		dots: false,
	})

	// * searchParams
	// *
	// * search params to url
	const searchParams = () => {
		if (window.location.search) {
			const URL = window.location.search.slice(1)
			let paramsURL = URL.split('&')

			paramsURL.forEach((param) => {
				let value = param.split('=')[0]
				let key = param.split('=')[1]

				switch (value) {
					case 'quad': // option quad
						scrollQuad(key)
						break
					default:
				}
			})
		}
	}

	const scrollQuad = (selectorElement) => {
		if (selectorElement === null || selectorElement === '') return

		try {
			let target = document.querySelector(`[data-tb-quad="${selectorElement}"]`)
			if (target === null) {
				target = document.querySelector(`#${selectorElement}`)
			}

			if (target === null) {
				target = document.querySelector(`.${selectorElement}`)
			}

			if (target === null) {
				console.error(`ERROR: there is no element with the class, id or data attribute "${selectorElement}"`)
				return
			}

			$('html, body').animate({ scrollTop: $(target).offset().top - 100 }, 800)
		} catch (error) {
			console.warn(`Error. Failed to execute ${error}`)
		}
	}

	searchParams()


	//anchor funcionality

	// function doScroll( id )  {
	// 	if( id ) {
	// 		let element = document.getElementById(id);

	// 		let position = element.getBoundingClientRect();
	// 			position = position.y;

	// 		window.scrollTo(  0 , position - 150 );
	// 	}

	// }

	// const siteURL = window.location.href;

	// if (siteURL.includes("#")) {
		
	// 	let neededId = siteURL.split("#");
	// 	neededId = neededId[1];
	// 	doScroll( neededId )
	// 	document.querySelector(`#${neededId}`).click();

	// }
	
	//end anchor funcionality

	// Class addition fall-happenings page
	let splashesQuad = document.getElementById("Splashes-&-15FiftyFive");
	if (splashesQuad) {
		splashesQuad.classList.add("splashes-fiftyfive")
	}


    // Date landing page

	let bw_landingPage = document.querySelector('.jsBookLanding');

	if( bw_landingPage ){
		let startDefaultDate = '',
			endDefaultDate = '',
			minDefaultDate = '';

		let currentPageName = document.querySelector('body').classList[0];

		switch (currentPageName) {
			case 'coastal-icon-transformation':
				startDefaultDate = '2024-08-30';
				endDefaultDate = '2024-09-02';
				minDefaultDate = '2024-08-30';
				break;
			default:
				startDefaultDate = '2024-08-01';
				endDefaultDate = '2024-08-04';
				minDefaultDate = '2024-08-01';
		}

		if (document.querySelector("#arriveInput")) {
	
		let arriveInput = document.querySelector("#arriveInput");

	
		flatpickr(arriveInput, {
			allowInput: true,
			dateFormat: "Y-m-d", 
			// defaultDate: startDefaultDate,
			// minDate: minDefaultDate, 
			minDate: new Date(), 
			onChange: function(selectedDates, dateStr, instance) {
	
				let initDate = dateStr;
				document.querySelector("[name=arrive]").value = initDate;
	
		
				let departureDate = new Date(selectedDates[0]);
				departureDate.setDate(departureDate.getDate() + 1);
				let departureDateStr = departureDate.toISOString().split('T')[0];
	
	
				if (document.querySelector("#departureInput")._flatpickr) {
					document.querySelector("#departureInput")._flatpickr.setDate(departureDateStr);
					document.querySelector("#departureInput")._flatpickr.set('minDate', departureDateStr);
				}
				document.querySelector("[name=depart]").value = departureDateStr;
			}
		});
		}
	
		if (document.querySelector("#departureInput")) {
	
			let departureInput = document.querySelector("#departureInput");
	
			flatpickr(departureInput, {
				allowInput: true,
				dateFormat: "Y-m-d", 
				// defaultDate: endDefaultDate,
				minDate: new Date()
			});
		}
	}


})()

if ($(".top-reasons-sliders").length > 0) {
    $(".top-reasons-sliders").each(function(index) {
      
        const sliderImages = $(this).find(".slider-images");
        const sliderInfo = $(this).find(".slider-info");
      
        sliderImages.slick({
            slidesToShow: 2,
            speed: 1000,
            arrows: true,
            asNavFor: sliderInfo,
            accessibility: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        swipe: true,
                        accessibility: true,
                    },
                },
            ],
        });
    
        sliderInfo.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            asNavFor: sliderImages,
            fade: true,
            adaptiveHeight: true,
            accessibility: true,
        });
    });
}



